import { Translation } from '../types';

export const cs: Translation = {
  common: {
    loading: 'Načítání...',
    error: 'Chyba',
    cancel: 'Zrušit',
    save: 'Uložit',
    close: 'Zavřít',
    search: 'Hledat',
    reload: 'Načíst znovu',
    logout: 'Odhlásit se',
    dashboard: 'Nástěnka',
    products: 'Produkty',
    settings: 'Nastavení',
    language: 'Jazyk',
    businessHours: 'Otevírací doba',
    back: 'Zpět',
    selectAll: 'Vybrat vše',
    deselectAll: 'Zrušit výběr všeho',
    success: 'Úspěch',
    selected: 'Vybráno',
    confirm: 'Potvrdit',
    required: 'Povinné',
    requiredMarker: '*',
    previous: 'Předchozí',
    next: 'Další',
    allRightsReserved: 'Všechna práva vyhrazena.',
  },
  auth: {
    login: 'Přihlášení',
    email: 'E-mailová adresa',
    password: 'Heslo',
    loginButton: 'Přihlásit se',
    loggingIn: 'Přihlašování...',
    loginSuccess: 'Přihlášení úspěšné',
    loginError: 'E-mail nebo heslo je nesprávné',
    invalidEmail: 'Zadejte prosím platnou e-mailovou adresu',
    requiredFields: 'Zadejte prosím e-mail a heslo',
    demoAccount: 'Demo účet:',
    loginDescription: 'Zadejte své údaje pro přihlášení',
    welcomeMessage: 'Vítejte v objednávkovém systému pro firmy',
    // Registration
    register: 'Registrovat',
    createAccount: 'Vytvořit účet',
    confirmPassword: 'Potvrdit heslo',
    passwordRequirements: 'Heslo musí mít alespoň 8 znaků a obsahovat velké písmeno, malé písmeno, číslo a speciální znak',
    passwordsDoNotMatch: 'Hesla se neshodují',
    registrationSuccess: 'Registrace úspěšná',
    registrationDescription: 'Zaregistrujte se pro firemní účet',
    alreadyHaveAccount: 'Máte již účet?',
    signIn: 'Přihlásit se',
    dontHaveAccount: "Nemáte účet?",
    creatingAccount: 'Vytváření účtu...',
    registrationNote: 'Poznámka:',
    registrationNotePoints: {
      erpLinking: 'Pokud máte existující firemní účet, váš e-mail bude automaticky propojen',
      companyEmail: 'Pro registraci použijte prosím svou firemní e-mailovou adresu',
      contactSupport: 'Kontaktujte podporu, pokud potřebujete pomoc s registrací'
    },
    b2bUsers: 'Uživatelé firemního účtu:',
    registeredEmail: 'Registrovaná e-mailová adresa',
    registeredPassword: 'Heslo nastavené při registraci',
    b2bCustomerRequired: 'Tato e-mailová adresa není registrována jako firemní zákazník. Kontaktujte prosím nejprve obchodní oddělení pro navázání obchodního vztahu.',
    b2bVerificationError: 'Nelze ověřit status firemního zákazníka. Kontaktujte prosím podporu.',
    // Password Reset
    passwordReset: 'Obnovení hesla',
    passwordResetDescription: 'Zadejte svou e-mailovou adresu pro získání dočasného hesla',
    getTemporaryPassword: 'Získat dočasné heslo',
    processing: 'Zpracování...',
    passwordResetComplete: 'Obnovení hesla dokončeno',
    temporaryPasswordGenerated: 'Dočasné heslo bylo vygenerováno',
    temporaryPassword: 'Dočasné heslo',
    backToLogin: 'Zpět na přihlášení',
    securityNotice: 'Bezpečnostní upozornění:',
    securityNotePoints: {
      keepSecret: 'Nesdílejte dočasné heslo s ostatními',
      changeAfterLogin: 'Po přihlášení si heslo nezapomeňte změnit',
      expires24Hours: 'Platnost dočasného hesla vyprší za 24 hodin'
    },
    resetNote: 'Poznámka:',
    resetNotePoints: {
      registeredEmail: 'Zadejte svou registrovanou e-mailovou adresu',
      passwordDisplayed: 'Dočasné heslo se zobrazí na obrazovce',
      changeRequired: 'Po přihlášení je vyžadována změna hesla'
    },
    copied: 'Zkopírováno',
    copySuccessMessage: 'Dočasné heslo zkopírováno do schránky.',
    forgotPassword: 'Zapomněli jste heslo?',
    // Password Reset Email Request
    sendResetLink: 'Odeslat odkaz pro obnovení',
    sendingEmail: 'Odesílání e-mailu...',
    emailSent: 'E-mail odeslán',
    emailSentMessage: 'Pokud tato e-mailová adresa existuje v našem systému, brzy obdržíte odkaz pro obnovení hesla.',
    emailNotSent: 'E-mail nebyl odeslán',
    emailSentInfo: 'Zkontrolujte svou doručenou poštu a složku se spamem',
    checkEmail: 'Zkontrolujte e-mail',
    emailInstructions: 'Pokyny pro obnovení hesla byly odeslány',
    nextSteps: 'Další kroky:',
    nextStepsList: {
      checkInbox: 'Zkontrolujte svou doručenou poštu a složku se spamem',
      clickLink: 'Klikněte na odkaz pro obnovení v e-mailu',
      linkExpires: 'Odkaz vyprší za 24 hodin',
      contactSupport: 'Kontaktujte podporu, pokud e-mail neobdržíte',
      rateLimitInfo: 'Omezeno na 3 žádosti za hodinu'
    },
    // Password Reset Completion
    resetLinkSent: 'Odkaz pro obnovení odeslán',
    resetSuccess: 'Heslo úspěšně obnoveno',
    passwordUpdated: 'Heslo aktualizováno',
    passwordUpdateMessage: 'Vaše heslo bylo úspěšně aktualizováno. Nyní se můžete přihlásit pomocí nového hesla.',
    loginWithNewPassword: 'Přihlásit se s novým heslem',
    // Reset Token Page
    resetToken: 'Obnovit heslo',
    invalidToken: 'Neplatný token pro obnovení',
    expiredToken: 'Platnost tokenu pro obnovení vypršela',
    tokenValid: 'Token pro obnovení je platný',
    newPassword: 'Nové heslo',
    confirmNewPassword: 'Potvrdit nové heslo',
    updatePassword: 'Aktualizovat heslo',
    updatingPassword: 'Aktualizace hesla...',
    passwordMismatch: 'Hesla se neshodují',
    resetInstructions: 'Zadejte své nové heslo pro dokončení obnovení',
  },
  accountInfo: {
    title: 'Informace o účtu',
    loading: 'Načítání informací o účtu...',
    error: 'Chyba',
    errorMessage: 'Nepodařilo se načíst informace o účtu',
    back: 'Zpět',
    basicInfo: 'Základní informace',
    name: 'Jméno',
    email: 'E-mailová adresa',
    contactId: 'Zákaznické ID Knitido',
    contactNumber: 'Kontaktní číslo',
    noInfo: 'Žádné informace',
    companyInfo: 'Informace o společnosti',
    company: 'Název společnosti',
    position: 'Pozice',
    vatId: 'DIČ',
    billingAddress: 'Fakturační adresa',
    deliveryAddress: 'Doručovací adresa',
    addressInfo: 'Informace o adrese',
    billingDescription: 'Adresa pro faktury a smluvní dokumenty',
    deliveryDescription: 'Standardní doručovací adresa pro zásilky produktů',
    sameAsBilling: '※ Stejná jako fakturační adresa',
    sameAsDelivery: '※ Stejná jako doručovací adresa',
    companyName: 'Název společnosti',
    contactPerson: 'Kontaktní osoba',
    address: 'Adresa',
    phoneNumber: 'Telefonní číslo',
    billingUsage: 'Používá se jako cíl pro faktury, smlouvy a další důležité dokumenty',
    deliveryUsage: 'Používá se jako standardní doručovací adresa pro objednané produkty',
    alsoUsedForDelivery: 'Používá se také jako doručovací adresa',
    accountType: 'Typ účtu',
    addressId: 'ID adresy',
    // Address editing functionality
    edit: 'Upravit',
    editDeliveryAddress: 'Upravit doručovací adresu',
    editDeliveryDescription: 'Aktualizujte informace o své doručovací adrese',
    newDeliveryAddress: 'Přidat novou doručovací adresu',
    newDeliveryDescription: 'Zadejte podrobnosti pro vaši novou doručovací adresu',
    noDeliveryAddress: 'Není nakonfigurována žádná doručovací adresa',
    success: 'Úspěch',
    addressUpdated: 'Doručovací adresa úspěšně aktualizována',
    updateError: 'Nepodařilo se aktualizovat doručovací adresu',
    requiredFields: 'Vyplňte prosím všechna povinná pole',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    streetAddress: 'Ulice a číslo',
    streetAddress2: 'Ulice a číslo 2',
    city: 'Město',
    country: 'Země',
    selectCountry: 'Vybrat zemi...',
    searchCountry: 'Hledat zemi...',
    noCountryFound: 'Země nenalezena.',
    postalCode: 'PSČ',
    companyNamePlaceholder: 'Zadejte název společnosti',
    firstNamePlaceholder: 'Jméno',
    lastNamePlaceholder: 'Příjmení',
    streetAddressPlaceholder: 'Zadejte ulici a číslo',
    streetAddress2Placeholder: 'Byt, apartmán atd.',
    cityPlaceholder: 'Zadejte město',
    postalCodePlaceholder: 'Zadejte PSČ',
    billingNotEditable: 'Fakturační adresu nelze upravovat.',
    billingContactSupport: 'Kontaktujte podporu pro změny.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} doručovacích adres',
    noDeliveryAddresses: 'Žádné doručovací adresy nejsou registrovány',
    defaultAddress: 'Výchozí',
    selectDeliveryAddress: 'Vybrat doručovací adresu',
    addNewAddress: 'Přidat novou adresu',
    editAddress: 'Upravit adresu',
    deleteAddress: 'Smazat adresu',
    confirmDelete: 'Potvrdit smazání',
    confirmDeleteMessage: 'Opravdu chcete smazat tuto adresu? Tuto akci nelze vrátit zpět.',
    addressAddedSuccess: 'Doručovací adresa přidána',
    addressDeletedSuccess: 'Doručovací adresa smazána',
    deleteError: 'Nepodařilo se smazat doručovací adresu',
    saving: 'Ukládání...',
    cancel: 'Zrušit',
    saveChanges: 'Uložit změny',
    selectedDeliveryAddress: 'Vybraná doručovací adresa',
  },
  dashboard: {
    title: 'Obchodní partner',
    subtitle: 'Systém objednávání produktů',
    welcome: 'Vítejte,',
    welcomeMessage: 'Vítejte v objednávkovém systému pro obchodní partnery. Zde si můžete objednat produkty.',
    productCatalog: 'Katalog produktů',
    productCatalogDesc: 'Procházet a objednávat dostupné produkty',
    viewProducts: 'Zobrazit produkty',
    orderHistory: 'Historie objednávek',
    orderHistoryDesc: 'Zobrazit minulé objednávky (již brzy)',
    accountSettings: 'Nastavení účtu',
    accountSettingsDesc: 'Správa informací o účtu (již brzy)',
    comingSoon: 'Již brzy',
    infoTitle: 'O používání',
    orderingInfo: 'Objednávání produktů',
    orderingDesc: 'Vyberte produkty z katalogu a zadejte velikost a barvu. K dispozici jsou informace o zásobách v reálném čase.',
    supportInfo: 'Podpora',
    supportDesc: 'Máte-li jakékoli dotazy, kontaktujte nás.',
    viewOrderHistory: 'Zobrazit historii objednávek',
    viewOrders: 'Zobrazit objednávky',
    accountInfo: 'Informace o účtu',
    accountInfoDesc: 'Zobrazit podrobnosti o vašem účtu',
    viewDetails: 'Zobrazit podrobnosti',
    supportEmail: 'b2b-partner @knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Pondělí-Pátek 9:00 - 15:00 SEČ',
    bulkImportDesc: 'Importovat objednávky ze souborů Excel/CSV',
    importOrders: 'Importovat objednávky',
  },
  products: {
    title: 'Seznam produktů',
    subtitle: 'Obchodní partner',
    searchPlaceholder: 'Hledat podle názvu produktu nebo SKU...',
    productId: 'ID produktu',
    addToCart: 'Přidat do košíku',
    selectVariation: 'Vybrat variantu',
    price: 'Cena',
    priceNetNotice: 'Všechny ceny jsou netto',
    stock: 'Sklad',
    color: 'Barva',
    newProducts: 'Nové produkty',
    newProductBadge: 'NOVÉ',
    size: 'Velikost',
    quantity: 'Množství',
    total: 'Celkem',
    cart: 'Košík',
    checkout: 'Pokladna',
    csvMode: 'Rychlý režim CSV',
    csvInfo: 'Data o produktech načtena z dat CSV',
    csvUploadDate: 'Datum nahrání CSV:',
    stockNote: '※ Informace o skladových zásobách se načítají při výběru variant produktů',
    noProducts: 'Nebyly nalezeny žádné produkty',
    noProductsDesc: 'Změňte kritéria vyhledávání nebo nahrajte soubor CSV pro rychlejší výkon.',
    retry: 'Zkusit znovu',
    pagination: 'položek',
    variations: 'variant',
    stockFetchError: 'Chyba načítání skladu',
    stockFetchFailed: 'Načítání skladu selhalo',
    stockFetchFailedDesc: 'Nepodařilo se načíst informace o skladových zásobách. Zobrazí se skladové zásoby z CSV.',
    stockFetched: 'Informace o skladových zásobách načteny',
    totalStock: 'Celkové zásoby',
    noStockAll: 'Všechny varianty mají nulové zásoby',
    noStockData: 'Nebyla vrácena žádná data o zásobách',
    stockFetchErrorDesc: 'Při načítání informací o skladových zásobách došlo k chybě',
    selectionError: 'Chyba výběru',
    enterQuantity: 'Zadejte prosím množství',
    addedToCart: 'Přidáno do košíku',
    typesAdded: ' typů produktů přidáno',
    addToCartError: 'Chyba přidání do košíku',
    addToCartErrorDesc: 'Zkuste to prosím znovu',
    loadingStock: 'Načítání informací o skladových zásobách',
    csvDataInfo: 'Zobrazení informací z dat CSV (nikoli skutečných skladových zásob)',
    invalidDataFormat: 'Formát dat produktu je neplatný',
    loadFailed: 'Nepodařilo se načíst data produktu',
    csvUploadComplete: 'Nahrání CSV dokončeno',
    csvLoadedDesc: ' dat produktů načteno. Informace o skladových zásobách budou načteny při výběru produktů.',
    searchTitle: 'Vyhledávání produktů',
    loadingProducts: 'Načítání dat produktů',
    noProductsCsv: 'V datech CSV nebyly nalezeny žádné produkty. Změňte prosím kritéria vyhledávání.',
    paginationDisplay: ' zobrazeno',
    previous: 'Předchozí',
    next: 'Další',
    selectionSummary: 'Souhrn výběru',
    selectedQuantity: 'Vybrané množství',
    items: ' položek',
    viewDetails: 'Zobrazit podrobnosti',
    productImage: 'Obrázek produktu',
    correspondingVariations: 'Odpovídající varianty',
    clickToEnlarge: 'Klikněte pro zvětšení',
    productIdLabel: 'ID produktu',
    colorLabel: 'Barva',
    filterByCategory: 'Filtrovat podle kategorie',
    allProducts: 'Všechny produkty',
    applyFilters: 'Použít filtry',
    clearFilters: 'Vymazat filtry',
    filters: 'Filtry',
    clearAll: 'Vymazat vše',
  },
  categories: {
    category_21: 'Prstové ponožky',
    category_23: 'Nezařazeno',
    category_24: 'Tělové prádlo',
    category_29: 'B2B produkty',
  },
  productDetail: {
    title: 'Podrobnosti o produktu',
    backToProducts: 'Zpět na produkty',
    productNotFound: 'Produkt nenalezen',
    productNotFoundDesc: 'Zadaný produkt neexistuje nebo byl smazán.',
    loading: 'Načítání produktu...',
    imageLoadError: 'Nepodařilo se načíst obrázky',
    noImages: 'Žádné obrázky nejsou k dispozici',
    productDescription: 'Popis produktu',
    colors: 'Barvy',
    sizes: 'Velikosti',
    colorCount: 'barev',
    sizeCount: 'velikostí',
    variationCount: 'variant',
    selectVariation: 'Vybrat varianty',
    descriptionLanguageNote: '※ Popisy produktů jsou k dispozici pouze v angličtině nebo němčině',
  },
  colors: {
    schwarz: 'Černá',
    weiß: 'Bílá',
    grau: 'Šedá',
    rot: 'Červená',
    blau: 'Modrá',
    grün: 'Zelená',
    gelb: 'Žlutá',
    rosa: 'Růžová',
    lila: 'Fialová',
    braun: 'Hnědá',
    orange: 'Oranžová',
    beige: 'Béžová',
    navy: 'Námořnická modrá',
    dunkelblau: 'Tmavě modrá',
    hellblau: 'Světle modrá',
    dunkelgrau: 'Tmavě šedá',
    hellgrau: 'Světle šedá',
    bordeaux: 'Bordeaux',
    türkis: 'Tyrkysová',
    khaki: 'Khaki',
    mint: 'Mátová',
    violett: 'Fialová',
    anthrazit: 'Antracitová',
    blaugrau: 'Modrošedá',
    burgunderrot: 'Vínová',
    elfenbein: 'Slonová kost',
    karminrot: 'Karmínová',
    neongrün: 'Neonově zelená',
    gelbgrün: 'Žlutozelená',
    pistazie: 'Pistáciová',
    // English color names (used in Product ID 237 etc.)
    blue: 'Modrá',
    ivory: 'Slonová kost',
    green: 'Zelená',
    gold: 'Zlatá',
    red: 'Červená',
  },
  checkout: {
    title: 'Pokladna',
    cartReview: 'Kontrola objednávky',
    orderSummary: 'Souhrn objednávky',
    shippingInfo: 'Informace o dopravě',
    billingInfo: 'Fakturační údaje',
    orderNotes: 'Poznámky k objednávce',
    orderNotesPlaceholder: 'Zvláštní požadavky nebo poznámky...',
    contactPerson: 'Kontaktní osoba',
    phoneNumber: 'Telefonní číslo',
    email: 'E-mailová adresa',
    company: 'Společnost',
    address: 'Adresa',
    city: 'Město',
    postalCode: 'PSČ',
    country: 'Země',
    deliveryDate: 'Datum doručení',
    urgentDelivery: 'Expresní doručení (3-5 pracovních dnů)',
    standardDelivery: 'Standardní doručení (7-10 pracovních dnů)',
    placeOrder: 'Odeslat objednávku',
    backToCart: 'Zpět na výběr produktů',
    requiredField: 'Povinné pole',
    orderTotal: 'Celkem k úhradě',
    subtotal: 'Mezisoučet',
    priceNetNotice: 'Všechny ceny jsou netto',
    stockReservationNotice: 'Rezervace skladu bude provedena po potvrzení objednávky.',
    stockCheckError: 'Chyba kontroly skladu',
    stockCheckErrorDesc: 'Při kontrole skladu došlo k chybě. Zkuste to prosím znovu.',
    shipping: 'Doprava',
    shippingCost: 'Náklady na dopravu',
    tax: 'Daň',
    orderSuccess: 'Objednávka úspěšná',
    orderSuccessMessage: 'Vaše objednávka byla úspěšně odeslána. Číslo objednávky: {orderNumber}',
    orderNumber: 'Číslo objednávky',
    thankYou: 'Děkujeme za vaši objednávku!',
    orderConfirmation: 'Vaše objednávka byla úspěšně odeslána.',
    orderProcessing: 'Po kontrole naším týmem vám zašleme potvrzení objednávky e-mailem.',
    orderProcessingMessage: 'Vaše objednávka byla úspěšně odeslána. Po kontrole naším týmem vám zašleme potvrzení objednávky e-mailem.',
    continueShopping: 'Pokračovat v nákupu',
    emptyCart: 'Váš košík je prázdný',
    emptyCartMessage: 'Pro pokračování přidejte produkty do košíku',
    stockWarning: 'Upozornění na sklad',
    stockWarningDesc: 'Některé položky nemají dostatečné zásoby. Upravte prosím množství.',
    stockError: 'Chyba skladu',
    stockErrorDesc: 'Některé položky mají nedostatečné zásoby. Upravte prosím množství.',
    refreshStock: 'Obnovit sklad',
    stockUpdated: 'Sklad aktualizován',
    stockUpdatedDesc: 'Sklad byl aktualizován - {changed} položek změněno',
    stockCheckDesc: 'Zobrazí se výsledky porovnání s inventářem',
    stockOk: 'Sklad OK',
    stockShortage: 'Nedostatek na skladě',
    requestedQty: 'Požadované mn.',
    currentStock: 'Aktuální sklad',
    stockShortageMsg: 'Nedostatečné zásoby. Upravte prosím množství.',
    stockIssueWarning: 'Objednávku nelze potvrdit kvůli problémům se skladem.',
    stockDataMissing: 'Data o skladových zásobách se načítají. Čekejte prosím chvíli.',
    outOfStock: 'Není skladem.',
    maxAvailable: 'Maximum',
    autoRestored: 'Košík byl obnoven',
    autoRestoredDesc: 'Položky z vaší poslední relace byly obnoveny',
    maxQuantityReached: 'Dosaženo maximálního množství skladem.',
    // ERP Contact Search
    contactSearch: 'Vyhledávání kontaktu zákazníka',
    contactSearchDesc: 'Zadejte e-mailovou adresu objednatele pro načtení kontaktních informací',
    emailAddress: 'E-mailová adresa',
    searchButton: 'Hledat',
    searching: 'Vyhledávání',
    contactFound: 'Kontakt nalezen',
    contactNotFound: 'Kontakt nenalezen',
    contactId: 'Zákaznické ID Knitido',
    companyName: 'Společnost',
    contactPersonLabel: 'Kontaktní osoba',
    addressesFound: 'Nalezené adresy',
    addressType: 'Typ',
    addressBilling: 'Fakturační adresa',
    addressDelivery: 'Doručovací adresa',
    vatSourceCompany: 'Info o společnosti',
    vatSourceBilling: 'Fakturace',
    vatSourceDelivery: 'Doručení',
    addressOther: 'Jiné',
    addressDetails: 'Adresa',
    loadingAddresses: 'Načítání informací o adrese...',
    addressRetrieved: 'Informace o adrese načteny',
    addressNotFound: 'Informace o adrese nenalezeny',
    addressNotFoundDesc: 'Žádné informace o adrese nejsou registrovány. Zadejte prosím ručně.',
    addressError: 'Chyba načítání adresy',
    addressErrorDesc: 'Nepodařilo se načíst informace o adrese.',
    contactNotConfirmed: 'Kontakt zákazníka nepotvrzen',
    contactNotConfirmedDesc: 'Zadejte prosím e-mailovou adresu a vyhledejte kontakt.',
    searchContact: 'Hledat kontakt',
    inputError: 'Chyba vstupu',
    inputErrorDesc: 'Informace o dopravě jsou neúplné. Zkontrolujte prosím.',
    processing: 'Zpracování...',
    erpContactSearch: 'Vyhledávání kontaktu zákazníka',
    contactSearchError: 'E-mailová adresa neodpovídá žádnému registrovanému kontaktu.',
    // Product Images Toggle
    showProductImages: 'Zobrazit obrázky produktů',
    showProductImagesDesc: 'Zobrazit obrázky produktů pro lepší přehled (může prodloužit dobu načítání)',
    // System Registration Info
    systemRegistrationInfo: 'Vaše informace o zákazníkovi',
    editShippingAddress: 'Upravit doručovací adresu',
    systemRegistrationInfoDesc: 'Vaše registrované obchodní informace. Kontaktujte prosím svého zástupce, pokud potřebujete aktualizovat fakturační údaje.',
    // Order Summary
    regularPrice: 'Běžná velkoobchodní cena',
    offeredPrice: 'Nabízená cena',
    discount: 'Sleva',
    b2bCustomer: 'B2B zákazník',
    pattern: 'Vzor',
    specialPriceApplied: 'Použita speciální cena',
    customerClassification: 'Klasifikace zákazníka',
    paymentCondition: 'Platební podmínky',
    invoice: 'Faktura (Splatnost 30 dní)',
    prepayment: 'Platba předem',
    paymentMethod: 'Způsob platby',
    invoicePayment: 'Platba fakturou',
    estimatedSubtotal: 'Odhadovaný mezisoučet',
    estimatedTotal: 'Odhadovaný součet',
    orderSummaryDisclaimer: 'Ceny zde uvedené jsou odhady. Jakmile obdržíme vaši objednávku, zkontrolujeme ji a zašleme vám závazné potvrzení objednávky s konečnými cenami, náklady na dopravu a daněmi e-mailem.',
    searchError: 'Chyba vyhledávání',
    searchErrorDesc: 'Během vyhledávání kontaktu došlo k chybě.',
    confirmDeleteItem: 'Odstranit položku',
    itemDeleted: 'Položka odstraněna',
    confirmDeleteItemDesc: 'Opravdu chcete odstranit následující položku z košíku?',
    deleteConfirm: 'Odstranit',
    contactNotes: 'Poznámky kontaktu',
    contactNotesDesc: 'Máte nějaké dotazy nebo zvláštní požadavky? Dejte nám prosím vědět (volitelné)',
    contactNotesLabel: 'Zpráva',
    contactNotesPlaceholder: 'např.: Dotazy k produktu, zvláštní požadavky atd.',
    characters: 'znaků',
    contactIdLabel: 'Zákaznické ID Knitido',
    companyLabel: 'Společnost',
    personLabel: 'Kontaktní osoba',
    emailLabel: 'E-mail',
    addressTypeLabel: 'Typ',
    destinationLabel: 'Cíl',
    // Shipping Form
    shippingTitle: 'Informace o dopravě',
    shippingDesc: 'Zadejte doručovací adresu pro produkty',
    companyRequired: 'Společnost *',
    contactPersonRequired: 'Kontaktní osoba *',
    emailRequired: 'E-mailová adresa *',
    phoneRequired: 'Telefonní číslo *',
    addressRequired: 'Adresa 1 *',
    address2: 'Adresa 2 (Budova/Místnost)',
    postalCodeRequired: 'PSČ *',
    cityRequired: 'Město *',
    countryRequired: 'Země *',
    selectCountry: 'Vybrat zemi',
    shippingMethodRequired: 'Způsob dopravy *',
    selectShippingMethod: 'Vybrat způsob dopravy',
    urgentDeliveryOption: 'Expresní doručení (dodatečné poplatky)',
    deliveryNotes: 'Poznámky k doručení',
    deliveryNotesPlaceholder: 'Zadejte preference času doručení nebo jiné požadavky',
    standardShipping: 'Standardní doprava (3-5 pracovních dnů)',
    expressShipping: 'Expresní doprava (1-2 pracovní dny)',
    overnightShipping: 'Doručení do druhého dne',
    germany: 'Německo',
    austria: 'Rakousko',
    switzerland: 'Švýcarsko',
    japan: 'Japonsko',
    shippingAddressLabel: 'Doručovací adresa',
    changeDeliveryAddress: 'Změnit doručovací adresu',
    selectDeliveryAddress: 'Vybrat doručovací adresu',
    // Shipping Cost Details
    freeShipping: 'Doprava zdarma',
    shippingError: 'Chyba',
    shippingZone: 'Doručovací zóna',
    remainingForFreeShipping: '{amount} zbývá pro dopravu zdarma',
    moreForFreeShipping: 'více pro dopravu zdarma',
    freeShippingProgress: 'Doprava zdarma při',
    andAboveFreeShipping: 'a více pro dopravu zdarma',
    freeShippingAchieved: 'Uplatněna doprava zdarma',
    threshold: 'a více',
    nextShippingTier: 'Další sleva na dopravu',
    moreForDiscount: 'více pro',
    shippingSavings: 'úspora na dopravě',
    orderAmountThreshold: 'a více pro',
    specialRegionNotice: 'Uplatněn speciální region dopravy',
    defaultShippingApplied: 'Uplatněny standardní sazby dopravy',
    requestedQuantity: 'Požadované množství',
    availableQuantity: 'Dostupné množství',
    orderSubmitError: 'Chyba odeslání objednávky',
    orderSubmitErrorDesc: 'Objednávku se nepodařilo odeslat',
    upload: {
      title: 'Importovat objednávku Excel/CSV',
      description: 'Nahrajte soubor Excel nebo CSV s daty vaší objednávky',
      dragDropOrClick: 'Přetáhněte soubor sem nebo klikněte pro výběr',
      dropHere: 'Přetáhněte soubor sem',
      supportedFormats: 'Podporované formáty: Excel (.xlsx, .xls) a CSV (.csv)',
      maxSize: 'Maximální velikost souboru: {size} MB',
      processFile: 'Zpracovat soubor',
      processing: 'Zpracování souboru...',
      ready: 'Soubor připraven k náhledu',
      readyDescription: 'Váš soubor byl úspěšně zpracován a je připraven ke kontrole.',
      preview: 'Zobrazit náhled',
      errors: {
        fileTooLarge: 'Soubor je příliš velký. Maximální velikost: {size} MB',
        invalidFileType: 'Neplatný typ souboru. Nahrajte prosím soubor Excel nebo CSV',
        uploadFailed: 'Chyba při nahrávání souboru',
      },
    },
    // Loading messages
    loadingPage: 'Načítání stránky...',
    loadingStock: 'Kontrola zásob produktů...',
    loadingAccount: 'Načítání informací o účtu...',
    loadingError: 'Došlo k chybě...',
    loadingData: 'Načítání dat',
    // Toast messages
    addressRetrievedTitle: 'Informace o adrese načteny',
    addressSetAsDelivery: ' adresa nastavena jako doručovací cíl.',
    contactFoundDesc: ' byl rozpoznán.'
  },
  orderHistory: {
    title: 'Historie objednávek',
    searchPlaceholder: 'Hledat podle čísla objednávky nebo SKU...',
    noOrders: 'Nebyly nalezeny žádné objednávky',
    noOrdersFound: 'Nebyly nalezeny žádné odpovídající objednávky',
    startShopping: 'Zobrazit produkty',
    orderItems: 'Položky objednávky',
    viewDetails: 'Podrobnosti',
    reorder: 'Objednat znovu',
    orderDate: 'Datum objednávky',
    orderStatus: 'Stav',
    orderTotal: 'Celkem k úhradě',
    // Status translations
    statusPending: 'Čeká na platbu',
    statusProcessing: 'Zpracovává se',
    statusConfirmed: 'Potvrzeno',
    statusShipped: 'Odesláno',
    statusDelivered: 'Doručeno',
    statusCancelled: 'Zrušeno',
    statusReturned: 'Vráceno',
    statusRefunded: 'Vráceno (peníze)',
    statusWarranty: 'Záruka',
    statusExchanged: 'Vyměněno',
    statusRepair: 'Oprava',
    statusUnknown: 'Neznámý',
    statusIncomplete: 'Neúplné',
    statusWaitingPayment: 'Čekání na platbu',
    statusInPreparation: 'V přípravě',
    statusClearedShipping: 'Schváleno k odeslání',
    statusBeingShipped: 'Odesílá se',
    statusOutgoingBooked: 'Odchozí rezervováno',
    statusReturn: 'Vrácení',
    // Additional UI elements
    itemCount: 'položek',
    itemCountSingular: 'položka',
    refreshButton: 'Obnovit',
    errorFetchingOrders: 'Nepodařilo se načíst historii objednávek',
    // Payment status features
    paymentStatus: 'Stav platby',
    markAsPaid: 'Označit jako zaplacené',
    unmarkAsPaid: 'Zrušit označení jako zaplacené',
    paidOn: 'Zaplaceno dne',
    paymentMarked: 'Zaplaceno',
    notPaid: 'Nezaplaceno',
    paymentMarkedSuccess: 'Úspěšně označeno jako zaplacené',
    paymentUnmarkedSuccess: 'Označení platby odstraněno',
    paymentUpdateError: 'Nepodařilo se aktualizovat stav platby',
    // Payment date dialog
    paymentDateTitle: 'Zadat informace o platbě',
    paymentDateDescription: 'Zadejte informace o platbě pro objednávku {orderNumber}',
    paymentDateLabel: 'Datum platby',
    selectDate: 'Vybrat datum',
    paymentDateHelp: 'Vyberte datum, kdy byl proveden bankovní převod',
    paymentMethodLabel: 'Způsob platby',
    bankTransfer: 'Bankovní převod',
    invoice: 'Faktura',
    otherPayment: 'Jiné',
    paymentReferenceLabel: 'Název převodu / Referenční číslo',
    paymentReferencePlaceholder: 'např. Jan Novák, Převod #12345',
    paymentReferenceHelp: 'Zadejte informace, které pomohou při párování s bankovními výpisy',
    notesLabel: 'Poznámky',
    notesPlaceholder: 'Zadejte jakékoli další informace o platbě',
    // Filter options
    filterByPaymentStatus: 'Filtrovat podle stavu platby',
    allOrders: 'Všechny objednávky',
    paidOrders: 'Zaplacené',
    unpaidOrders: 'Nezaplacené',
    // Sorting options
    sortBy: 'Seřadit podle',
    sortByDate: 'Datum objednávky',
    sortByPaymentDate: 'Datum platby',
    sortByAmount: 'Částka',
    sortByStatus: 'Stav',
  },
  orderDetails: {
    title: 'Podrobnosti o objednávce',
    notFound: 'Objednávka nenalezena',
    backToHistory: 'Zpět na historii objednávek',
    orderDate: 'Datum objednávky',
    orderItems: 'Položky objednávky',
    deliveryStatus: 'Stav doručení',
    estimatedDelivery: 'Odhadované doručení',
    deliveredOn: 'Doručeno dne',
    downloadInvoice: 'Stáhnout fakturu',
    statusDelivered: 'Doručeno',
    statusShipped: 'Odesláno',
    statusConfirmed: 'Potvrzeno',
    statusCancelled: 'Zrušeno',
    errorFetchingDetails: 'Nepodařilo se načíst podrobnosti o objednávce',
  },
  company: {
    name: 'Obchodní partner',
    tagline: 'Systém pro obchodní partnery',
    copyright: '© 2025 Systém pro obchodní partnery. Všechna práva vyhrazena.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-mail',
    countries: {
      DE: 'Německo',
      AT: 'Rakousko',
      CH: 'Švýcarsko',
      FR: 'Francie',
      IT: 'Itálie',
      ES: 'Španělsko',
      NL: 'Nizozemsko',
      BE: 'Belgie',
      PL: 'Polsko',
      SE: 'Švédsko',
      NO: 'Norsko',
      FI: 'Finsko',
      DK: 'Dánsko',
      LT: 'Litva',
      LV: 'Lotyšsko',
      EE: 'Estonsko',
    },
  },
  cart: {
    newCart: 'Nový košík',
    currentCart: 'Aktuální košík',
    modified: 'změněno',
    lastSaved: 'Naposledy uloženo',
    unsavedChanges: 'neuložené změny',
    saveCart: 'Uložit košík',
    loadCart: 'Načíst košík',
    deleteCart: 'Smazat košík',
    startNewCart: 'Začít nový košík',
    savedCarts: 'Uložené košíky',
    cartSaved: 'Košík uložen',
    cartDeleted: 'Košík smazán',
    confirmDeleteCart: 'Smazat košík?\n\n{count} položek bude odstraněno.\n\nTuto akci nelze vrátit zpět.',
    confirmSwitchCart: 'Aktuální košík má neuložené změny.\n\nNačtení jiného košíku způsobí ztrátu aktuálních změn.\n\nPokračovat?',
    confirmSwitchCartTitle: 'Přepnout košík',
    confirmNewCart: 'Aktuální košík má neuložené změny.\n\nZahájení nového košíku způsobí ztrátu aktuálních změn.\n\nPokračovat?',
    confirmNewCartTitle: 'Začít nový košík',
    confirmClearCart: 'Vyprázdnit košík?\n\n{count} položek bude odstraněno.\n\nTuto akci nelze vrátit zpět.',
    confirmClearCartTitle: 'Vyprázdnit košík',
    autoSaved: 'Automaticky uloženo',
    itemsWillBeRemoved: 'položek bude odstraněno',
    changesWillBeLost: 'změny budou ztraceny',
    continueQuestion: 'Pokračovat?',
    cartStatus: 'Stav košíku',
    cartName: 'Název košíku',
    cartNamePlaceholder: 'např.: Objednávka na konci měsíce',
    cartNameRequired: 'Zadejte prosím název košíku',
    saveCartDescription: 'Pojmenujte aktuální košík a uložte jej. Můžete jej načíst později.',
    cancelCart: 'Zrušit košík',
    proceedToCheckout: 'Pokračovat k pokladně',
    emptyCart: 'Košík je prázdný',
    erpDown: 'Objednávkový systém je mimo provoz. Zkuste to prosím znovu později.',
    erpDegraded: 'Systém je momentálně nestabilní. Objednávky mohou selhat.',
    erpDownSaveHint: 'Uložte svůj košík a objednejte po obnovení systému.',
    erpSaveCart: 'Uložit košík',
  },
  nav: {
    dashboard: 'Nástěnka',
    products: 'Produkty',
    orderHistory: 'Historie objednávek',
    account: 'Info o účtu',
    bulkImport: 'Hromadný import',
  },
  settings: {
    selectLanguage: 'Vyberte jazyk',
    languagePreferenceSaved: 'Vaše preference bude uložena k vašemu účtu pro budoucí návštěvy.',
  },
  reorder: {
    allItemsAdded: '{count} položek přidáno do košíku',
    partialSuccess: '{added} položek přidáno. {failed} položek se nepodařilo přidat',
    allItemsFailed: 'Nepodařilo se přidat položky do košíku',
    error: 'Při opětovném objednání došlo k chybě',
    itemDiscontinued: '{name} ({color}/{size}) byl vyřazen z nabídky',
    itemOutOfStock: '{name} ({color}/{size}) není skladem',
    partialStock: '{name} ({color}/{size}) k dispozici pouze {available}',
    confirmReorder: 'Potvrdit opětovné objednání',
    confirmReorderMessage: 'Přidat položky z této objednávky do košíku?',
    addingToCart: 'Přidávání do košíku...',
    checkingStock: 'Kontrola skladu...',
    checkoutTitle: 'Položky přidány do košíku',
    checkoutDescription: '{count} položek bylo přidáno do vašeho košíku. Chcete přejít k pokladně?',
  },
  bulkImport: {
    instructions: 'Jak importovat objednávky',
    step1: 'Stáhněte si šablonu objednávky',
    step2: 'Vyplňte data objednávky s SKU a množstvím',
    step3: 'Uložte jako soubor Excel (.xlsx) nebo CSV',
    step4: 'Nahrajte soubor pomocí formuláře níže',
    step5: 'Zkontrolujte a potvrďte svou objednávku',
    downloadTemplate: 'Stáhnout šablonu',
    downloadExcelTemplate: 'Stáhnout šablonu Excel',
    downloadCsvTemplate: 'Stáhnout šablonu CSV',
    formatGuide: 'Průvodce formátem souboru',
    requiredColumns: 'Povinné sloupce',
    skuDescription: 'Kód SKU produktu',
    quantityDescription: 'Objednané množství (kladné celé číslo)',
    optionalColumns: 'Volitelné sloupce',
    notesDescription: 'Interní poznámky (např. číslo objednávky, reference) - pouze pro vaši evidenci',
    formatNote: 'První řádek by měl obsahovat záhlaví sloupců. Data začínají od druhého řádku.',
    parseSuccess: 'Úspěšně zpracováno {count} položek ze souboru',
    parseError: 'Chyba zpracování',
    validationError: 'Chyby ověření',
    validationErrorGuidance: 'Klikněte prosím na tlačítko "{showPreviewButton}" pro zobrazení podrobností.',
    warnings: 'Varování',
    itemsParsed: 'Úspěšně zpracováno {count} položek:',
    andMore: '...a {count} dalších položek',
    validationSummary: 'Souhrn ověření',
    duplicateSKUs: 'Nalezeny duplicitní SKU',
    skuFormat: 'SKU musí obsahovat pouze písmena, čísla a pomlčky',
    quantityRange: 'Množství musí být mezi 1 a 9999',
    maxRows: 'Povoleno maximálně 1000 řádků',
    rowsSkipped: '{count} řádků bylo přeskočeno kvůli chybám',
    previewTitle: 'Náhled objednávky',
    previewDescription: 'Zkontrolujte a upravte data objednávky před pokračováním',
    proceedToCart: 'Přidat do košíku',
    // File parsing messages
    fileEmpty: 'Soubor je prázdný nebo neobsahuje žádná data',
    fileTooManyRows: 'Soubor obsahuje příliš mnoho řádků ({current}). Maximální povolené: {max}',
    invalidRowFormat: 'Neplatný formát řádku',
    missingColumns: 'Chybí povinné sloupce (SKU a Množství)',
    missingSku: 'Chybí SKU',
    invalidSkuFormat: 'Neplatný formát SKU: "{sku}" (musí odpovídat vzoru: {pattern})',
    skuTooLong: 'SKU je příliš dlouhé: "{sku}" (maximálně 50 znaků)',
    invalidQuantity: 'Neplatné množství: "{quantity}" není číslo',
    quantityTooLow: 'Množství je příliš nízké: {quantity} (minimum: {min})',
    quantityTooHigh: 'Množství je příliš vysoké: {quantity} (maximum: {max})',
    notesRequired: 'Pole poznámek je povinné',
    noValidData: 'Nebyla nalezena žádná platná data. Zkontrolujte prosím formát souboru.',
    row: 'Řádek {row}: {errors}',
    rowErrors: '...a {count} dalších chyb',
    duplicateSkuInRows: 'Duplicitní SKU "{sku}" nalezeno v řádcích: {rows}',
    quantityExceedsMax: 'Řádek {row}: Množství {quantity} překračuje maximální povolené ({max})',
    quantityBelowMin: 'Řádek {row}: Množství {quantity} je pod minimem požadovaným ({min})',
    // Validation messages
    unsupportedFileFormat: 'Nepodporovaný formát souboru. Nahrajte prosím soubor CSV nebo Excel.',
    csvParsingErrors: 'Došlo k chybám při zpracování CSV',
    failedToParseFile: 'Nepodařilo se zpracovat soubor',
    failedToParseExcel: 'Nepodařilo se zpracovat soubor Excel',
    failedToReadFile: 'Nepodařilo se přečíst soubor',
    unknownError: 'Došlo k neznámé chybě',
    totalRows: 'Celkem řádků',
    valid: 'Platné',
    invalid: 'Neplatné',
    skipped: 'Přeskočeno',
    // SKU validation
    skuValidationError: 'Chyba ověření SKU',
    skuValidationFailed: 'Nepodařilo se ověřit SKU. Můžete pokračovat, ale některé položky nemusí být k dispozici.',
    skuNotFound: 'SKU nenalezeno v databázi',
    skusNotFound: '{count} SKU nenalezeno v databázi',
    itemsHaveInsufficientStock: '{count} položek má nedostatečné zásoby',
    validatingSKUs: 'Ověřování položek...',
    unvalidatedChanges: 'Máte neověřené změny. Před přidáním do košíku je prosím znovu ověřte.',
    revalidate: 'Znovu ověřit',
    validating: 'Ověřování...',
    validationSuccess: 'Všechny položky jsou platné',
    validationComplete: 'Ověření dokončeno',
    validationResultSummary: 'Nalezeno {errors} chyb, {warnings} varování',
    // Table headers
    actions: 'Akce',
    notes: 'Poznámky',
    // Status filter
    all: 'Vše',
    hasErrors: 'Má chyby',
    // Selection summary
    selected: 'vybráno',
    errors: 'chyby',
    // Pagination
    page: 'Stránka {current} z {total}',
    previous: 'Předchozí',
    next: 'Další',
    noResults: 'Žádné výsledky.',
    // Cart integration
    noValidItems: 'Žádné platné položky',
    allItemsHaveErrors: 'Všechny položky mají chyby ověření. Před pokračováním je prosím opravte.',
    dataLoadingError: 'Chyba načítání dat',
    failedToLoadProductData: 'Nepodařilo se načíst data o produktu. Zkuste to prosím znovu.',
    itemsAddedToCart: '{count} položek přidáno do košíku',
    itemsAddedMessage: 'Do košíku přidáno {count} položek',
    someSkusNotFound: '{count} SKU se nepodařilo nalézt.',
    noItemsAdded: 'Nebyly přidány žádné položky',
    couldNotFindProducts: 'Nepodařilo se najít žádné produkty odpovídající SKU.',
    errorAddingToCart: 'Chyba',
    failedToAddToCart: 'Nepodařilo se přidat položky do košíku. Zkuste to prosím znovu.',
    addingToCart: 'Přidávání do košíku...',
    // File info
    fileSelected: '{name} vybráno pro zpracování',
    fileSize: '{size} bajtů',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Stažení šablony',
    templateWillBeImplemented: 'Stažení šablony bude implementováno ve Fázi 7',
    // Additional validation
    validationFailed: 'Ověření selhalo',
    // Template download
    templateDownloaded: 'Šablona úspěšně stažena',
    templateDownloadError: 'Nepodařilo se stáhnout šablonu',
    // Template content
    sheetName: 'Hromadná objednávka',
    instructionsSheetName: 'Instrukce',
    columnDescriptions: 'Popis sloupců:',
    columnHeader: 'Sloupec',
    columnRequired: 'Povinné',
    columnOptional: 'Volitelné',
    columnDescription: 'Popis',
    templateNotes: 'Poznámky:',
    templateNote1: 'První řádek musí obsahovat záhlaví sloupců přesně tak, jak je uvedeno',
    templateNote2: 'Data začínají od řádku 2',
    templateNote3: 'SKU musí odpovídat existujícím kódům produktů v systému',
    templateNote4: 'Množství musí být kladné celé číslo mezi 1 a 9999',
    templateNote5: 'Maximálně 1000 řádků na soubor',
    templateNote6: 'Uložte jako formát .xlsx nebo .csv',
    stockAvailabilityWarning: 'Skutečná dostupnost zásob bude zkontrolována na další stránce pokladny.',
    outOfStock: 'Není skladem',
    insufficientStock: 'Nedostatečné zásoby: k dispozici {available}, požadováno {requested}',
  },
  orderExport: {
    export: 'Exportovat objednávku',
    exportOrder: 'Exportovat data objednávky',
    exportAsCSV: 'Exportovat jako CSV',
    exportAsExcel: 'Exportovat jako Excel',
    exportForReorder: 'Exportovat pro hromadný import',
    detailed: 'Úplné podrobnosti',
    simpleFormat: 'Formát importu',
  },
};
